import React, { useState, useEffect } from 'react';
import { Box, TextField, Button, Typography, Divider } from '@mui/material';
import koLocale from 'date-fns/locale/ko';
import DateAdapter from '@mui/lab/AdapterDateFns';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import DatePicker from '@mui/lab/DatePicker';
;


export const SearchBox = ({ formik, handleDownExcel }) => {
    const [searchStrtDt, setSearchStrtDt] = useState(null);
    const [searchEndDt, setSearchEndDt] = useState(null);

    useEffect(() => {
        if (formik.values.searchStrtDt !== null) {
            setSearchStrtDt(formik.values.searchStrtDt)
        }
        if (formik.values.searchEndDt !== null) {
            setSearchEndDt(formik.values.searchEndDt)
        }
    }, [formik.values.searchStrtDt, formik.values.searchEndDt]);

    const onChangeDate = (newValue, name) => {
        formik.setFieldValue(name, newValue);
    };

    return (
        <Box
            component="form"
            noValidate
            autoComplete="off"
            sx={{
                mx: 1
            }}
            onSubmit={formik.handleSubmit}
        >


            <Box sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                <Box><LocalizationProvider dateAdapter={DateAdapter} locale={koLocale}>
                    <DatePicker
                        label="매출 시작일"
                        inputFormat={'yyyy-MM-dd'}
                        mask={'____-__-__'}
                        id="searchStrtDt"
                        name="searchStrtDt"
                        value={searchStrtDt}
                        onChange={(newValue) => {
                            setSearchStrtDt(newValue);
                            onChangeDate(newValue, 'searchStrtDt');
                        }}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                variant="standard"
                                fullWidth
                                error={
                                    formik.touched.searchStrtDt &&
                                    Boolean(formik.errors.searchStrtDt)
                                }
                                helperText={
                                    formik.touched.searchStrtDt && formik.errors.searchStrtDt
                                }
                            />
                        )}
                    />
                </LocalizationProvider></Box>
                <Box sx={{ mx: 1 }}> <LocalizationProvider dateAdapter={DateAdapter} locale={koLocale}>
                    <DatePicker
                        label="매출 종료일"
                        inputFormat={'yyyy-MM-dd'}
                        mask={'____-__-__'}
                        id="searchEndDt"
                        name="searchEndDt"
                        value={searchEndDt}
                        onChange={(newValue) => {
                            setSearchEndDt(newValue);
                            onChangeDate(newValue, 'searchEndDt');
                        }}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                variant="standard"
                                fullWidth
                                error={
                                    formik.touched.searchEndDt &&
                                    Boolean(formik.errors.searchEndDt)
                                }
                                helperText={
                                    formik.touched.searchEndDt && formik.errors.searchEndDt
                                }
                            />
                        )}
                    />
                </LocalizationProvider>
                </Box>
                <Box sx={{ ml: 2 }}>
                    <Button
                        type="submit"
                        color="info"
                        variant="contained"
                        disabled={formik.isSubmitting}
                    >
                        검색
                    </Button>
                </Box>
                <Box sx={{ mx: 1 }}>
                    <Button
                        type="button"
                        color="success"
                        variant="contained"
                        onClick={handleDownExcel}
                    >
                        엑셀 다운로드
                    </Button></Box>
            </Box>
        </Box>
    );
};
